/* PURE DÉTAIL — effets premium (chargé par sections/pd-effects.liquid) */
(function () {
  'use strict';

  var root = document.documentElement;
  root.classList.add('pd-js');

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var inEditor = !!(window.Shopify && window.Shopify.designMode);

  /* ---------- Barre de progression + en-tête au défilement ---------- */
  var progress = document.createElement('div');
  progress.className = 'pd-progress';
  progress.setAttribute('aria-hidden', 'true');
  document.body.appendChild(progress);

  var heroMedia = document.querySelectorAll('[data-pd-parallax]');
  var ticking = false;

  function onScroll() {
    var y = window.scrollY || window.pageYOffset;
    var max = document.documentElement.scrollHeight - window.innerHeight;
    progress.style.transform = 'scaleX(' + (max > 0 ? Math.min(y / max, 1) : 0) + ')';
    document.body.classList.toggle('pd-scrolled', y > 40);

    if (!reduceMotion) {
      for (var i = 0; i < heroMedia.length; i++) {
        var el = heroMedia[i];
        var rect = el.parentNode.getBoundingClientRect();
        if (rect.bottom > 0 && rect.top < window.innerHeight) {
          el.style.transform = 'translate3d(0,' + (-rect.top * 0.28).toFixed(1) + 'px,0)';
        }
      }
    }
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; window.requestAnimationFrame(onScroll); }
  }, { passive: true });
  window.addEventListener('resize', onScroll);
  onScroll();

  /* ---------- Apparition au défilement ---------- */
  function cleanup(el) {
    el.classList.remove('pd-reveal', 'pd-in');
    el.style.removeProperty('--pd-delay');
  }

  var io = ('IntersectionObserver' in window && !reduceMotion && !inEditor)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          io.unobserve(el);
          el.classList.add('pd-in');
          var done = function (e) {
            if (e && e.target !== el) return;
            el.removeEventListener('transitionend', done);
            cleanup(el);
          };
          el.addEventListener('transitionend', done);
          setTimeout(done, 2200);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 })
    : null;

  function reveal(el, delay) {
    if (!io || el.dataset.pdRevealed) return;
    el.dataset.pdRevealed = '1';
    if (delay) el.style.setProperty('--pd-delay', delay + 's');
    el.classList.add('pd-reveal');
    io.observe(el);
  }

  function scan(scope) {
    scope = scope || document;
    // Sections de page (sauf la bannière d'accueil qui a sa propre animation)
    scope.querySelectorAll('.dynamic-sections > .shopify-section:not(.pd-hero-section)').forEach(function (s) {
      if (s.querySelector('.pd-stagger')) return; // les sections PD animent leurs enfants
      reveal(s);
    });
    // Éléments internes en cascade
    scope.querySelectorAll('.pd-stagger').forEach(function (group) {
      Array.prototype.forEach.call(group.children, function (child, i) {
        reveal(child, Math.min(i, 8) * 0.09);
      });
    });
    // Grilles de produits hors carrousel (pages collection / recherche)
    scope.querySelectorAll('.collection-feed .product-wrap, .collection-matrix .product-wrap, .search-results .product-wrap').forEach(function (card, i) {
      reveal(card, (i % 4) * 0.08);
    });
  }
  scan();

  // Contenu chargé dynamiquement (filtres de collection, pagination)
  if ('MutationObserver' in window) {
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      setTimeout(function () { pending = false; scan(); }, 120);
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- Halo rouge qui suit la souris sur les cartes ---------- */
  if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
    document.addEventListener('pointermove', function (e) {
      var card = e.target.closest && e.target.closest('.product-wrap, .pd-card');
      if (!card) return;
      var r = card.getBoundingClientRect();
      card.style.setProperty('--pd-mx', (e.clientX - r.left) + 'px');
      card.style.setProperty('--pd-my', (e.clientY - r.top) + 'px');
    }, { passive: true });
  }

  /* ---------- Compteurs animés ---------- */
  var counters = document.querySelectorAll('[data-pd-count]');
  if (counters.length) {
    var runCounter = function (el) {
      var target = parseFloat(el.getAttribute('data-pd-count')) || 0;
      var suffix = el.getAttribute('data-pd-suffix') || '';
      if (reduceMotion) { el.textContent = target + suffix; return; }
      var start = null;
      var step = function (t) {
        if (!start) start = t;
        var p = Math.min((t - start) / 1600, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(target * eased) + suffix;
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };
    if ('IntersectionObserver' in window) {
      var cio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { cio.unobserve(en.target); runCounter(en.target); } });
      }, { threshold: 0.4 });
      counters.forEach(function (c) { cio.observe(c); });
    } else {
      counters.forEach(runCounter);
    }
  }

  /* ---------- Réassurance sous le bouton d'achat (fiche produit) ---------- */
  var buy = document.querySelector('.product-main .purchase-details');
  if (buy && !document.querySelector('.pd-trust')) {
    var icon = {
      truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h11v9H3z"/><path d="M14 9h4l3 3v3h-7z"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg>',
      shield: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l8 3v6c0 4.5-3.4 8-8 9-4.6-1-8-4.5-8-9V6z"/><path d="M8.5 12l2.5 2.5 4.5-5"/></svg>',
      chat: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 5h16v11H9l-5 4z"/><path d="M8 10h8M8 13h5"/></svg>'
    };
    var trust = document.createElement('div');
    trust.className = 'pd-trust';
    trust.innerHTML =
      '<div class="pd-trust__item">' + icon.truck + '<span>Livraison gratuite dès 150&nbsp;$</span></div>' +
      '<div class="pd-trust__item">' + icon.shield + '<span>Revendeur autorisé</span></div>' +
      '<div class="pd-trust__item">' + icon.chat + '<span>Conseils de pros</span></div>';
    buy.parentNode.insertBefore(trust, buy.nextSibling);
  }

  /* ---------- Fiche produit : « Lire la suite » pour les longues descriptions ---------- */
  var desc = document.querySelector('.product-main .product__description');
  if (desc && !desc.dataset.pdReady) {
    desc.dataset.pdReady = '1';
    desc.classList.add('pd-desc');
    if (desc.scrollHeight > 340) {
      desc.classList.add('is-clamped');
      var more = document.createElement('button');
      more.type = 'button';
      more.className = 'pd-desc-toggle';
      more.setAttribute('aria-expanded', 'false');
      more.innerHTML = 'Lire la suite <span aria-hidden="true">↓</span>';
      more.addEventListener('click', function () {
        var open = desc.classList.toggle('is-clamped') === false;
        more.classList.toggle('is-open', open);
        more.setAttribute('aria-expanded', open ? 'true' : 'false');
        more.firstChild.nodeValue = open ? 'Réduire ' : 'Lire la suite ';
      });
      desc.parentNode.insertBefore(more, desc.nextSibling);
    }
  }

  /* ---------- Fil d'Ariane : « All » (collection automatique) devient « Boutique » ---------- */
  document.querySelectorAll('.product-breadcrumb a').forEach(function (a) {
    if (/^\s*all\s*$/i.test(a.textContent)) { a.textContent = 'Boutique'; a.setAttribute('href', '/collections'); }
  });

  /* ---------- Hauteur de l'en-tête collant (pour les barres collantes en dessous) ---------- */
  var headerEl = document.querySelector('.shopify-section.header-section');
  function setHeaderH() {
    if (headerEl) root.style.setProperty('--pd-header-h', Math.round(headerEl.getBoundingClientRect().height) + 'px');
  }
  setHeaderH();
  window.addEventListener('resize', setHeaderH);

  /* ---------- Barre « livraison gratuite » mise à jour en direct ---------- */
  var ship = document.querySelector('[data-pd-ship]');
  if (ship) {
    var threshold = parseInt(ship.getAttribute('data-threshold'), 10) || 0;
    var shipMsg = ship.querySelector('[data-pd-ship-msg]');
    var shipBar = ship.querySelector('[data-pd-ship-bar]');
    var fmt = function (cents) { return (cents / 100).toFixed(2) + ' $'; };
    var refreshShip = function () {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var total = c.total_price || 0;
          var left = threshold - total;
          shipBar.style.width = Math.max(6, Math.min(100, threshold ? total * 100 / threshold : 100)) + '%';
          shipMsg.innerHTML = left > 0
            ? 'Plus que <strong>' + fmt(left) + '</strong> pour obtenir la <strong>livraison gratuite</strong>'
            : 'Bravo ! Votre <strong>livraison est gratuite</strong> 🎉';
          ship.hidden = c.item_count === 0;
        })
        .catch(function () {});
    };
    var cartForm = document.getElementById('cart_form');
    if (cartForm && 'MutationObserver' in window) {
      var shipTimer;
      new MutationObserver(function () {
        clearTimeout(shipTimer);
        shipTimer = setTimeout(refreshShip, 400);
      }).observe(cartForm, { childList: true, subtree: true, characterData: true });
    }
  }

  /* ---------- Diaporama de la bannière d'accueil ---------- */
  function initHeroSlider(hero) {
    var slider = hero.querySelector('[data-pd-slider]');
    if (!slider || slider.dataset.pdReady) return;
    var slides = Array.prototype.slice.call(slider.querySelectorAll('.pd-hero__slide'));
    if (slides.length < 2) return;
    slider.dataset.pdReady = '1';
    var bars = Array.prototype.slice.call(hero.querySelectorAll('[data-pd-slide-to]'));
    var num = hero.querySelector('[data-pd-slide-num]');
    var ms = (parseFloat(slider.getAttribute('data-interval')) || 6) * 1000;
    var i = Math.max(0, slides.findIndex(function (s) { return s.classList.contains('is-active'); }));
    var timer = null;
    var paused = false;

    function show(n) {
      slides[i].classList.remove('is-active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active');
      // relance l'animation de zoom de la photo active
      var img = slides[i].querySelector('.pd-hero__img');
      if (img) { img.style.animation = 'none'; void img.offsetWidth; img.style.animation = ''; }
      bars.forEach(function (b, k) {
        b.classList.remove('is-active');
        b.classList.toggle('is-done', k < i);
        b.setAttribute('aria-selected', k === i ? 'true' : 'false');
      });
      if (bars[i]) { void bars[i].offsetWidth; bars[i].classList.add('is-active'); }
      if (num) num.textContent = (i + 1 < 10 ? '0' : '') + (i + 1);
      schedule();
    }
    function schedule() {
      clearTimeout(timer);
      if (!reduceMotion && !paused) timer = setTimeout(function () { show(i + 1); }, ms);
    }

    bars.forEach(function (b, k) { b.addEventListener('click', function () { show(k); }); });
    var prev = hero.querySelector('[data-pd-slide-prev]');
    var next = hero.querySelector('[data-pd-slide-next]');
    if (prev) prev.addEventListener('click', function () { show(i - 1); });
    if (next) next.addEventListener('click', function () { show(i + 1); });

    // Glisser du doigt sur mobile
    var x0 = null;
    hero.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 50) show(dx < 0 ? i + 1 : i - 1);
      x0 = null;
    }, { passive: true });

    // Pause quand l'onglet est caché
    document.addEventListener('visibilitychange', function () {
      paused = document.hidden;
      hero.classList.toggle('is-paused', paused);
      if (paused) clearTimeout(timer); else schedule();
    });

    // Éditeur de thème : afficher la photo sélectionnée
    document.addEventListener('shopify:block:select', function (e) {
      var k = slides.indexOf(e.target);
      if (k > -1) { paused = true; show(k); }
    });
    document.addEventListener('shopify:block:deselect', function () { paused = false; schedule(); });

    show(i);
  }
  document.querySelectorAll('.pd-hero').forEach(initHeroSlider);

  /* ---------- Vidéo d'ambiance de la bannière ---------- */
  function initHeroVideo(hero) {
    var wrap = hero.querySelector('[data-pd-hero-video]');
    if (!wrap || wrap.dataset.pdReady) return;
    wrap.dataset.pdReady = '1';
    var desk = wrap.querySelector('.pd-hero__vid--desktop, [data-pd-vid="desktop"]');
    var mob = wrap.querySelector('.pd-hero__vid--mobile, [data-pd-vid="mobile"]');
    var btn = hero.querySelector('[data-pd-video-toggle]');
    var saveData = navigator.connection && navigator.connection.saveData;
    if (reduceMotion || saveData) return; // l'image de fond reste affichée
    var mq = window.matchMedia('(max-width: 749px)');
    var current = null, userPaused = false, visible = true;

    function pick() { return (mq.matches && mob) ? mob : (desk || mob); }
    function play() {
      if (!current || userPaused || !visible || document.hidden) return;
      var p = current.play();
      if (p && p.catch) p.catch(function () {});
    }
    function setup() {
      var v = pick();
      if (v === current) return;
      if (current) { current.pause(); current.classList.remove('is-playing'); }
      current = v;
      if (!current) return;
      current.muted = true; current.setAttribute('muted', ''); current.playsInline = true;
      if (current.preload !== 'auto') { current.preload = 'auto'; current.load(); }
      play();
    }
    [desk, mob].forEach(function (v) {
      if (!v) return;
      v.addEventListener('playing', function () { if (v === current) v.classList.add('is-playing'); });
    });
    if (btn) {
      btn.hidden = false;
      btn.addEventListener('click', function () {
        userPaused = !userPaused;
        btn.classList.toggle('is-paused', userPaused);
        btn.setAttribute('aria-label', userPaused ? 'Relancer la vidéo' : 'Mettre la vidéo en pause');
        if (userPaused) { if (current) current.pause(); } else play();
      });
    }
    // Pause hors écran et quand l'onglet est caché (économie de batterie)
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        visible = en[0].isIntersecting;
        if (visible) play(); else if (current) current.pause();
      }, { threshold: 0.05 }).observe(hero);
    }
    document.addEventListener('visibilitychange', function () { if (document.hidden) { if (current) current.pause(); } else play(); });
    if (mq.addEventListener) mq.addEventListener('change', setup);
    setup();
  }
  document.querySelectorAll('.pd-hero, .pd-vband').forEach(initHeroVideo);

  /* ---------- Pagination : « Page X sur Y » ---------- */
  function labelPagination() {
    document.querySelectorAll('.pagination').forEach(function (nav) {
      if (nav.previousElementSibling && nav.previousElementSibling.classList.contains('pd-page-count')) return;
      var cur = nav.querySelector('.pagination-link.is-current');
      if (!cur) return;
      var nums = Array.prototype.map.call(nav.querySelectorAll('.pagination-link'), function (a) { return parseInt(a.textContent, 10) || 0; });
      var total = Math.max.apply(null, nums);
      var p = document.createElement('p');
      p.className = 'pd-page-count';
      p.innerHTML = 'Page <strong>' + cur.textContent.trim() + '</strong> sur ' + total;
      nav.parentNode.insertBefore(p, nav);
      cur.setAttribute('aria-current', 'page');
    });
  }
  labelPagination();
  if ('MutationObserver' in window) {
    var pagTimer;
    new MutationObserver(function () { clearTimeout(pagTimer); pagTimer = setTimeout(labelPagination, 200); })
      .observe(document.body, { childList: true, subtree: true });
  }

  var CFG = window.PD || {};
  var SHIP = CFG.ship || 15000;
  var money = function (cents) { return '$' + (cents / 100).toFixed(2) + ' CAD'; };
  var escapeHtml = function (s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };

  /* ---------- Fiche produit : stock faible + barre d'achat collante ---------- */
  var productMain = document.querySelector('.product-main');
  var addBtn = productMain && productMain.querySelector('.purchase-details .button--add-to-cart');
  function currentVariant() {
    var el = productMain && productMain.querySelector('[data-kit-selected-variant]');
    var idInput = productMain && productMain.querySelector('form[action*="/cart/add"] [name="id"]');
    if (!el) return null;
    try {
      var v = JSON.parse(el.textContent);
      if (idInput && String(v.id) !== String(idInput.value)) return null;
      return v;
    } catch (e) { return null; }
  }

  if (productMain && addBtn) {
    // Indicateur de stock (basé sur le vrai inventaire de la variante)
    var stock = document.createElement('div');
    stock.className = 'pd-stock';
    stock.hidden = true;
    var buyZone = productMain.querySelector('.purchase-details');
    buyZone.parentNode.insertBefore(stock, buyZone);
    var renderStock = function () {
      var v = currentVariant();
      if (!v || v.inventory_management !== 'shopify' || v.inventory_policy !== 'deny' || !v.available) { stock.hidden = true; return; }
      var q = v.inventory_quantity;
      var max = CFG.lowStock || 5;
      stock.hidden = false;
      if (q > 0 && q <= max) {
        stock.className = 'pd-stock pd-stock--low';
        stock.innerHTML = '<span class="pd-stock__dot"></span><span>Plus que <strong>' + q + '</strong> en stock, commandez bientôt</span>' +
          '<span class="pd-stock__bar"><span style="width:' + Math.max(8, Math.round(q / max * 100)) + '%"></span></span>';
      } else if (q > max) {
        stock.className = 'pd-stock pd-stock--ok';
        stock.innerHTML = '<span class="pd-stock__dot"></span><span>En stock</span>';
      } else { stock.hidden = true; }
    };

    // Barre d'achat collante
    var sticky = null;
    if (CFG.stickyAtc !== false) {
      var titleEl = productMain.querySelector('.product-title');
      var imgEl = productMain.querySelector('.product-gallery__image img, .product-gallery__main img');
      sticky = document.createElement('div');
      sticky.className = 'pd-sticky-atc';
      sticky.setAttribute('aria-hidden', 'true');
      sticky.innerHTML =
        '<div class="pd-sticky-atc__inner">' +
          '<img class="pd-sticky-atc__img" alt="" hidden>' +
          '<div class="pd-sticky-atc__info"><span class="pd-sticky-atc__title">' + escapeHtml(titleEl ? titleEl.textContent.trim() : '') + '</span>' +
          '<span class="pd-sticky-atc__meta"><span class="pd-sticky-atc__variant"></span><span class="pd-sticky-atc__price"></span></span></div>' +
          '<button type="button" class="pd-sticky-atc__btn" tabindex="-1">Ajouter au panier</button>' +
        '</div>';
      document.body.appendChild(sticky);
      var sBtn = sticky.querySelector('.pd-sticky-atc__btn');
      sBtn.addEventListener('click', function () {
        if (addBtn.disabled) return;
        addBtn.click();
        sBtn.classList.add('is-added');
        sBtn.textContent = 'Ajouté ✓';
        setTimeout(function () { sBtn.classList.remove('is-added'); renderSticky(); }, 1800);
      });
      var renderSticky = function () {
        var v = currentVariant();
        var priceEl = sticky.querySelector('.pd-sticky-atc__price');
        var varEl = sticky.querySelector('.pd-sticky-atc__variant');
        if (v) { priceEl.textContent = money(v.price); varEl.textContent = v.public_title ? v.public_title + ' · ' : ''; }
        // Miniature : photo de la variante, sinon première photo réellement chargée de la galerie
        var thumb = sticky.querySelector('.pd-sticky-atc__img');
        var src = (v && v.featured_image && v.featured_image.src) || '';
        if (!src && imgEl) {
          src = imgEl.getAttribute('data-src') || imgEl.currentSrc || imgEl.src || '';
          if (/^data:/.test(src)) src = '';
        }
        if (src) {
          src = src.replace(/\{width\}/g, '160');
          if (!/width=/.test(src)) src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=160';
          if (thumb.getAttribute('src') !== src) thumb.setAttribute('src', src);
          thumb.hidden = false;
        }
        if (!sBtn.classList.contains('is-added')) sBtn.textContent = addBtn.disabled ? 'Épuisé' : 'Ajouter au panier';
        sBtn.disabled = !!addBtn.disabled;
      };
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          var e = en[0];
          var show = !e.isIntersecting && e.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
          sBtn.tabIndex = show ? 0 : -1;
          document.body.classList.toggle('pd-has-sticky-atc', show);
        }).observe(addBtn);
      }
    }

    var refreshProduct = function () { renderStock(); if (sticky) renderSticky(); };
    refreshProduct();
    var form = productMain.querySelector('form[action*="/cart/add"]');
    if (form) {
      form.addEventListener('change', function () { setTimeout(refreshProduct, 350); });
      if ('MutationObserver' in window) {
        var pTimer;
        new MutationObserver(function () { clearTimeout(pTimer); pTimer = setTimeout(refreshProduct, 150); })
          .observe(form, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['value', 'disabled'] });
      }
    }
  }

  /* ---------- Mini-panier : jauge de livraison gratuite ---------- */
  if (CFG.miniCartBar !== false) {
    var miniCart = document.getElementById('theme-ajax-cart');
    if (miniCart) {
      var fillMini = function (bar) {
        fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
          if (!c.item_count) { bar.hidden = true; return; }
          var left = SHIP - c.total_price;
          bar.hidden = false;
          bar.querySelector('.pd-mini-ship__msg').innerHTML = left > 0
            ? 'Plus que <strong>' + (left / 100).toFixed(2) + ' $</strong> pour la <strong>livraison gratuite</strong>'
            : 'Votre <strong>livraison est gratuite</strong> 🎉';
          bar.querySelector('.pd-mini-ship__bar').style.width = Math.max(6, Math.min(100, c.total_price * 100 / SHIP)) + '%';
        }).catch(function () {});
      };
      var ensureMini = function () {
        var cartBox = miniCart.querySelector('.ajax-cart');
        if (!cartBox) return;
        var bar = cartBox.querySelector('.pd-mini-ship');
        if (!bar) {
          bar = document.createElement('div');
          bar.className = 'pd-mini-ship';
          bar.hidden = true;
          bar.innerHTML = '<p class="pd-mini-ship__msg"></p><div class="pd-mini-ship__track"><div class="pd-mini-ship__bar"></div></div>';
          var title = cartBox.querySelector('.ajax-cart__cart-title');
          if (title && title.parentNode) title.parentNode.insertBefore(bar, title.nextSibling); else cartBox.insertBefore(bar, cartBox.firstChild);
        }
        fillMini(bar);
      };
      ensureMini();
      if ('MutationObserver' in window) {
        var mTimer;
        new MutationObserver(function (list) {
          var own = list.every(function (m) { return m.target.closest && m.target.closest('.pd-mini-ship'); });
          if (own) return;
          clearTimeout(mTimer); mTimer = setTimeout(ensureMini, 250);
        }).observe(miniCart, { childList: true, subtree: true });
      }
    }
  }

  /* ---------- Pastilles sur les cartes produits ---------- */
  if (CFG.badges !== false) {
    var getHandles = function (handle) {
      var key = 'pd-col-' + handle;
      try {
        var cached = JSON.parse(sessionStorage.getItem(key) || 'null');
        if (cached && Date.now() - cached.t < 30 * 60 * 1000) return Promise.resolve(cached.h);
      } catch (e) {}
      return fetch('/collections/' + handle + '/products.json?limit=250', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) {
          var h = (d.products || []).map(function (p) { return p.handle; });
          try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), h: h })); } catch (e) {}
          return h;
        })
        .catch(function () { return []; });
    };
    var badgeSets = null;
    var applyBadges = function () {
      if (!badgeSets) return;
      document.querySelectorAll('.product-wrap').forEach(function (card) {
        if (card.dataset.pdBadged) return;
        var link = card.querySelector('a[href*="/products/"]');
        var holder = card.querySelector('.product-image__wrapper, .image__container');
        if (!link || !holder) return;
        card.dataset.pdBadged = '1';
        var m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
        var handle = m && decodeURIComponent(m[1]);
        var priceTxt = (card.querySelector('.product-thumbnail__price') || {}).textContent || '';
        var label = null, cls = '';
        if (/épuisé|sold out/i.test(priceTxt)) { label = 'Épuisé'; cls = 'out'; }
        else if (badgeSets.nouveau.indexOf(handle) > -1) { label = 'Nouveau'; cls = 'new'; }
        else if (badgeSets.populaire.indexOf(handle) > -1) { label = 'Populaire'; cls = 'hot'; }
        if (!label) return;
        holder.style.position = 'relative';
        var b = document.createElement('span');
        b.className = 'pd-badge pd-badge--' + cls;
        b.textContent = label;
        holder.appendChild(b);
        if (cls === 'out') card.classList.add('pd-is-soldout');
      });
    };
    Promise.all([getHandles('nouveautes'), getHandles('nos-meilleurs-vendeurs')]).then(function (res) {
      badgeSets = { nouveau: res[0], populaire: res[1] };
      applyBadges();
      if ('MutationObserver' in window) {
        var bTimer;
        new MutationObserver(function () { clearTimeout(bTimer); bTimer = setTimeout(applyBadges, 200); })
          .observe(document.body, { childList: true, subtree: true });
      }
    });
  }

  /* ---------- Bouton « retour en haut » avec anneau de progression ---------- */
  if (CFG.backToTop !== false) {
    var backTop = document.createElement('button');
    backTop.type = 'button';
    backTop.className = 'pd-top';
    backTop.setAttribute('aria-label', 'Retour en haut');
    backTop.innerHTML = '<svg class="pd-top__ring" viewBox="0 0 48 48" aria-hidden="true"><circle cx="24" cy="24" r="22"/><circle class="pd-top__prog" cx="24" cy="24" r="22"/></svg>' +
      '<svg class="pd-top__arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';
    document.body.appendChild(backTop);
    var prog = backTop.querySelector('.pd-top__prog');
    var C = 2 * Math.PI * 22;
    prog.style.strokeDasharray = C;
    var topTick = false;
    var updTop = function () {
      var y = window.scrollY || window.pageYOffset;
      var max = document.documentElement.scrollHeight - window.innerHeight;
      backTop.classList.toggle('is-visible', y > 600);
      prog.style.strokeDashoffset = C * (1 - (max > 0 ? Math.min(y / max, 1) : 0));
      topTick = false;
    };
    window.addEventListener('scroll', function () { if (!topTick) { topTick = true; requestAnimationFrame(updTop); } }, { passive: true });
    updTop();
    // Se place juste au-dessus de la bulle « Chat » (Shopify Inbox), où qu'elle soit (mobile, barre d'achat collante…)
    var chatBtn = function () {
      var host = document.querySelector('shopify-chat, #shopify-chat');
      var root = host && host.shadowRoot;
      var btn = root && (root.querySelector('button.activator') || root.querySelector('button'));
      if (!btn) return null;
      var r = btn.getBoundingClientRect();
      return r.width > 0 && r.height > 0 && r.top < window.innerHeight ? r : null;
    };
    var placeTop = function () {
      var r = chatBtn();
      backTop.classList.toggle('pd-top--alone', !r);
      if (r) {
        backTop.style.bottom = Math.round(window.innerHeight - r.top + 12) + 'px';
        backTop.style.right = Math.max(8, Math.round(document.documentElement.clientWidth - r.right + (r.width - 52) / 2)) + 'px';
      } else {
        backTop.style.bottom = ''; backTop.style.right = '';
      }
    };
    placeTop();
    window.addEventListener('resize', placeTop);
    setInterval(placeTop, 800); // la bulle se charge tard et bouge avec la barre d'achat collante
    backTop.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' }); });
  }

  /* ---------- Routine : la ligne rouge se remplit au défilement ---------- */
  var routines = document.querySelectorAll('[data-pd-routine]');
  if (routines.length) {
    var rTick = false;
    var updRoutine = function () {
      routines.forEach(function (r) {
        var rect = r.getBoundingClientRect();
        var vh = window.innerHeight;
        var p = Math.min(1, Math.max(0, (vh * 0.85 - rect.top) / (rect.height * 0.9)));
        r.style.setProperty('--pd-routine-p', reduceMotion ? 1 : p.toFixed(3));
        var steps = r.querySelectorAll('.pd-routine__step');
        steps.forEach(function (s, k) { s.classList.toggle('is-lit', p >= (k / Math.max(1, steps.length - 1)) * 0.98 || reduceMotion); });
      });
      rTick = false;
    };
    window.addEventListener('scroll', function () { if (!rTick) { rTick = true; requestAnimationFrame(updRoutine); } }, { passive: true });
    updRoutine();
  }

  /* ---------- Témoins (cookies) — Loi 25 : bandeau relié à l'API de confidentialité de Shopify ---------- */
  // Tant que le visiteur n'a pas choisi, le bandeau s'affiche. Son choix est transmis à Shopify
  // (setTrackingConsent) : refuser coupe réellement les statistiques et les pixels marketing.
  if (CFG.cookies !== false && window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
      var cp = window.Shopify.customerPrivacy;
      if (err || !cp) return;
      var privacyUrl = (window.Shopify.routes && window.Shopify.routes.root || '/') + 'policies/privacy-policy';
      var box = document.createElement('div');
      box.className = 'pd-cookies';
      box.setAttribute('role', 'dialog');
      box.setAttribute('aria-live', 'polite');
      box.setAttribute('aria-label', 'Témoins (cookies)');
      var cats = [
        ['analytics', 'Statistiques', 'Mesurer les visites pour améliorer le site.'],
        ['marketing', 'Marketing', 'Publicités et offres adaptées à vos intérêts.'],
        ['preferences', 'Préférences', 'Retenir vos choix (langue, panier…).']
      ];
      box.innerHTML =
        '<p class="pd-cookies__title">Votre vie privée compte</p>' +
        '<p class="pd-cookies__text">Nous utilisons des témoins (cookies) pour faire fonctionner le site et, avec votre accord, pour mesurer l\'achalandage et personnaliser nos offres. ' +
        '<a href="' + privacyUrl + '">Politique de confidentialité</a></p>' +
        '<div class="pd-cookies__prefs" hidden>' +
          '<label class="pd-cookies__row"><span><strong>Essentiels</strong><small>Panier, paiement, sécurité. Toujours actifs.</small></span><input type="checkbox" checked disabled></label>' +
          cats.map(function (c) { return '<label class="pd-cookies__row"><span><strong>' + c[1] + '</strong><small>' + c[2] + '</small></span><input type="checkbox" data-cat="' + c[0] + '"></label>'; }).join('') +
        '</div>' +
        '<div class="pd-cookies__actions">' +
          '<button type="button" class="pd-cookies__btn pd-cookies__btn--ghost" data-act="refuse">Refuser</button>' +
          '<button type="button" class="pd-cookies__btn pd-cookies__btn--ghost" data-act="custom">Personnaliser</button>' +
          '<button type="button" class="pd-cookies__btn" data-act="accept">Tout accepter</button>' +
        '</div>';
      document.body.appendChild(box);
      var prefs = box.querySelector('.pd-cookies__prefs');
      var customBtn = box.querySelector('[data-act="custom"]');
      var open = function (showPrefs) {
        var cur = cp.currentVisitorConsent ? cp.currentVisitorConsent() : {};
        box.querySelectorAll('input[data-cat]').forEach(function (i) { i.checked = cur[i.getAttribute('data-cat')] === 'yes'; });
        prefs.hidden = !showPrefs;
        customBtn.textContent = showPrefs ? 'Enregistrer mes choix' : 'Personnaliser';
        box.classList.add('is-open');
      };
      var save = function (values) {
        cp.setTrackingConsent(values, function () {});
        box.classList.remove('is-open');
      };
      box.addEventListener('click', function (e) {
        var act = e.target.closest('[data-act]');
        if (!act) return;
        var a = act.getAttribute('data-act');
        if (a === 'accept') save({ analytics: true, marketing: true, preferences: true });
        else if (a === 'refuse') save({ analytics: false, marketing: false, preferences: false });
        else if (prefs.hidden) open(true);
        else {
          var v = {};
          box.querySelectorAll('input[data-cat]').forEach(function (i) { v[i.getAttribute('data-cat')] = i.checked; });
          save(v);
        }
      });
      // Lien permanent dans le pied de page pour changer d'avis
      var foot = document.querySelector('footer');
      if (foot) {
        var link = document.createElement('button');
        link.type = 'button';
        link.className = 'pd-cookie-link';
        link.textContent = 'Gérer les témoins (cookies)';
        link.addEventListener('click', function () { open(true); });
        foot.appendChild(link);
      }
      var c = cp.currentVisitorConsent ? cp.currentVisitorConsent() : {};
      var decided = c.analytics || c.marketing || c.preferences; // '' tant qu'aucun choix
      if (!decided) setTimeout(function () { open(false); }, 900);
    });
  }

  /* ---------- Éditeur de thème : ré-analyser quand une section est rechargée ---------- */
  document.addEventListener('shopify:section:load', function (e) {
    heroMedia = document.querySelectorAll('[data-pd-parallax]');
    e.target.querySelectorAll('.pd-hero').forEach(initHeroSlider);
    e.target.querySelectorAll('.pd-hero, .pd-vband').forEach(initHeroVideo);
    scan(e.target);
    onScroll();
  });
})();
